import { useState, useCallback } from "react";
import { fetchChatHistory } from "../../services/consultationService";
import { formatTimestamp } from "../../utils/TimeFormatter";

export const useChat = (consulatationId, headers) => {
    const [chatMessages, setChatMessages] = useState([]);
    const [isLoadingChat, setIsLoadingChat] = useState(false);

    const addMessage = useCallback((msg) => {
        setChatMessages((prev) => {
            if (msg.id && prev.find(m => m.id === msg.id)) return prev;
            return [...prev, msg];
        });
    }, []);

    const fetchChat = useCallback(async (customId) => {
        const id = customId || consulatationId;
        if (!id) return;

        setIsLoadingChat(true);
        try {
            const res = await fetchChatHistory(id, headers);
            if (res?.data && Array.isArray(res.data.chat)) {
                const formattedMessages = res.data.chat.map((item) => ({
                    id: item._id || Date.now() + Math.random(),
                    text: item.message,
                    isUser: item.sender === "User",
                    timestamp: formatTimestamp(item.createdAt),
                }));
                setChatMessages(formattedMessages);
            } else if (res?.data && Array.isArray(res.data)) {
                const formattedMessages = res.data.map((item) => ({
                    id: item._id || Date.now() + Math.random(),
                    text: item.message,
                    isUser: item.sender === "User",
                    timestamp: formatTimestamp(item.createdAt),
                }));
                setChatMessages(formattedMessages);
            }
        } catch (error) {
            console.error("Error fetching chat history:", error);
        } finally {
            setIsLoadingChat(false);
        }
    }, [consulatationId, headers]);

    return { chatMessages, setChatMessages, addMessage, fetchChat, isLoadingChat };
};